import doc               from '@widesk-core/decorators/doc';
import AbstractMenuModel from './AbstractMenuModel';
import appStore          from '@/stores/appStore';

export type MenuPageMode = 'desktop' | 'mobile';

@doc.urnResource('menu')
export default class MenuModel extends AbstractMenuModel {
	public getDashboardPath(mode: MenuPageMode): string {
		return this.pagePathPrefix + `/menus/mode/${mode}/${this.id}`;
	}

	public static getSplitViewPath(mode: MenuPageMode): string {
		return `/menus/mode/${mode}/split`;
	}

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	// Provides a default mode "desktop" for pagePath
	// Example: renderName({ link: true }) will result in "desktop" mode
	public get pagePath(): string {
		return this.pagePathPrefix + `/menu/mode/desktop/${this.id}`;
	}

	get pagePathPrefix(): string {
		return `/website_entertainments/${appStore.websiteEntertainment?.id}`;
	}
}
